<template>
  <div  v-loading="loading">
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
      <el-card header="基础信息" shadow="naver">
        <el-form-item label-width="100px" label="标题">
          <el-input v-model="form.title" placeholder="标题"></el-input>
        </el-form-item>

        <el-form-item label-width="100px" label="活动分类">
          <el-select v-model="form.activitycate" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label-width="100px" label="活动时间">
          <el-col :span="20">
            <el-date-picker
              v-model="activity_date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="过期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label-width="100px" label="活动内容">
          <el-input v-model="form.url" placeholder="活动内容"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="排序">
          <el-input v-model="form.act_sort" placeholder="排序"></el-input>
        </el-form-item>

        <el-form-item label="图片" label-width="100px" prop="img">
          <div @click="handleImgPicker('img')" class="upload-box">
            <img v-if="form.img" :src="form.img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
          <!-- <div class="frm-tips">
            只能上传jpg/png文件，且不超过2M
          </div> -->
        </el-form-item>
        <el-form-item label="模板样式" v-if="form.activitycate == 5" label-width="100px">
          <el-radio-group v-model="form.sc_id" size="small" @change="mubanChange">
            <el-radio-button v-for="(item,i) in sucaiData" :key="i" :label="item.id">{{item.title}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板背景" v-if="form.activitycate == 5" label-width="100px" prop="current_url">
          <div @click="handleImgPicker('current_url')" class="upload-box">
            <img v-if="form.current_url" :src="form.current_url" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
          <div class="frm-tips">
            温馨提示：修改模板时一定要仔细检查，替换的模板样式必须与固定模板样式保持一致；<br>
              如替换素材模板与固定样式不一致，分享素材会出现排版错乱，每次替换操作都将记录日志，请细心操作哦~
          </div>
        </el-form-item>
      </el-card>
      <el-card header="绑定商品" shadow="naver">
        <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
      </el-card>
      <el-card header="设置商品" shadow="naver">
        <el-table v-if="form.items.length>0" :data="form.items" style="line-height: normal">
          <el-table-column label="商品ID" prop="sku_id" width="100"></el-table-column>
          <el-table-column label="商品货号" prop="sku_bn" width="150"></el-table-column>
          <el-table-column label="商品名称" prop="sku_name"  width="250"></el-table-column>
<!--          <el-table-column label="类型" prop="cat_name">-->
<!--            <template slot-scope="scope">-->
<!--              <span style="color:blue">{{scope.row.cat_name}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="限量团购" width="80">-->
<!--            <template slot-scope="scope">-->
<!--              <el-input v-model="scope.row.max_sell" size="mini"></el-input>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="排序" width="80">
            <template slot-scope="scope">
              <el-input v-model="scope.row.act_sort" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="营销图标ID" width="100">-->
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.tui_icon" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <i class="iconfont icon-trash-alt" @click="deleteItemRow(scope.$index, form.items)"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-form-item class="content-center">
        <el-button @click.native="handleCancel">返回</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submitActivityAction()">保存</el-button>
      </el-form-item>
    </el-form>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>

  </div>
</template>

<script>
import {createActivity, updateActivity, activityGetInfo, sucaiList} from '../../../api/sharer'
import imgPicker from '@/components/imageselect'
import SkuSelector from '@/components/function/sharerSkuSelector'
export default {
  inject: ['refresh'],
  components: { imgPicker, SkuSelector },
  data () {
    return {
      loading: false,
      btnLoading: false,
      params: {
        page: 1,
        pageSize: 20
      },
      form: {
        act_id: '',
        title: '',
        activitycate: '',
        url: '',
        act_sort: '',
        img: '',
        start_time: '',
        end_time: '',
        items: [],
        sc_id: '',
        current_url: ''
      },
      pickerImgType: '',
      imgDialog: false,
      isGetImage: false,
      options: [{
        value: '1',
        label: '社群分享'
      }, {
        value: '2',
        label: '限量团购'
      }, {
        value: '3',
        label: '会员升级'
      }, {
        value: '4',
        label: '赠品活动'
      }, {
        value: '5',
        label: '素材分享'
      }],
      activity_date: '',
      relItems: [],
      addedItems: [],
      sucaiData: []
    }
  },
  methods: {
    submitActivityAction () {
      this.btnLoading = true
      const that = this
      if (this.activity_date) {
        this.form.start_time = this.activity_date[0]
        this.form.end_time = this.activity_date[1]
      }
      if (!this.form.title || !this.form.activitycate || !this.form.start_time || !this.form.end_time || this.form.items.length == 0) {
        this.btnLoading = false
        this.$message.error('请完善活动信息!')
        return false
      }
      if (this.form.activitycate == 5 && !this.form.img) {
        this.btnLoading = false
        this.$message.error('请上传图片!')
        return false
      }
      if (this.form.activitycate == 5 && (!this.form.sc_id || !this.form.current_url)) {
        this.btnLoading = false
        this.$message.error('请选择模板!')
        return false
      }
      let params = JSON.stringify(this.form)
      params = JSON.parse(params)
      params.items = JSON.stringify(params.items)
      console.log(params.items)
      if (this.form.act_id) {
        updateActivity(params).then(res => {
          if (res.data.data.act_id) {
            this.loading = false
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.btnLoading = false
            this.$message.error('保存失败!')
            return false
          }
        })
      } else {
        createActivity(params).then(res => {
          if (res.data.data.act_id) {
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.btnLoading = false
            this.$message.error('保存失败!')
            return false
          }
        })
      }
      setTimeout(() => {
        this.btnLoading = false
      }, 5000)
    },
    pickImg (data) {
      this.form[this.pickerImgType] = data.url
      this.imgDialog = false
    },
    handleImgPicker (pickerImgType) {
      this.pickerImgType = pickerImgType
      this.imgDialog = true
      this.isGetImage = true
    },
    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
    },
    getItems (data) {
      let arr = []
      data.forEach((item, index) => {
        let newData = ''
        let isInArr = this.addedItems.findIndex((n) => n.sku_id == item.sku_id)
        // console.log(isInArr)
        if (isInArr == -1) {
          newData = {
            sku_id: item.sku_id,
            sku_bn: item.sku_bn,
            sku_name: item.sku_name,
            tui_icon: item.tui_icon,
            act_sort: item.act_sort || 0,
            max_sell: item.max_sell || 500
          }
        } else {
          newData = this.addedItems[isInArr]
        }
        arr.push(newData)
      })
      this.form.items = arr
    },
    getActivityDetail (id) {
      this.loading = true
      activityGetInfo({act_id: id}).then(res => {
        let response = res.data.data
        // console.log(response)
        let data = {
          // 复制活动提交去掉秒杀id
          act_id: this.copy_flag ? '' : response.act_id,
          title: response.title,
          activitycate: response.activitycate,
          url: response.url,
          act_sort: response.act_sort,
          img: response.img,
          start_time: response.start_time,
          end_time: response.end_time,
          sc_id: response.sc_id,
          current_url: response.current_url,
          items: ''
        }
        Object.assign(this.form, data)
        // 替换一下
        response.items.forEach((item, index) => {
          response.itemTreeLists.forEach((item2, index2) => {
            if (response.itemTreeLists[index2].sku_id == response.items[index].sku_id) {
              response.itemTreeLists[index2].act_sort = item.act_sort
              response.itemTreeLists[index2].max_sell = item.max_sell
            }
          })
        })
        this.addedItems = response.itemTreeLists
        this.activity_date = [response.start_date, response.end_date]
        this.relItems = response.itemTreeLists || []
        this.loading = false
      })
    },
    deleteItemRow: function (index, rows) {
      rows.splice(index, 1)
      this.form.items = rows
      this.setItemStatus = false
      this.relItems.splice(index, 1)
    },
    getSucai () {
      sucaiList().then(response => {
        this.sucaiData = response.data.data.list
      })
    },
    mubanChange (id) {
      let arr = this.sucaiData
      let index = arr.findIndex((arr) => arr.id == id)
      this.form.sc_id = this.sucaiData[index]['id']
      this.form.current_url = this.sucaiData[index]['current_url']
    },
    handleCancel: function () {
      this.$router.go(-1)
    }
  },
  mounted () {
    if (this.$route.params.act_id) {
      this.getActivityDetail(this.$route.params.act_id)
    }
    this.getSucai()
  },
  watch: {
    // 分页全选-监听数据变化
    // form: {
    //   handler (value) {
    //     console.log(value)
    //   },
    //   deep: true
    // }
  }
}
</script>




// WEBPACK FOOTER //
// activity_add.vue?7ae9848a